export default __webpack_public_path__ + "static/signature-m-b88d16da9e02d84961f4f5be9bd44189.png";